import axios from 'axios';
import { lazy, memo, Suspense, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { apiURL } from '../api';
import Loading from '../components/layouts/Loading';

const AlertMessage = lazy(() => import('../components/layouts/AlertMessage'));

const Contact = () => {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    content: '',
  });
  const { fullName, email, phone, content } = formData;
  const { t } = useTranslation();

  const onChangeFormData = useCallback(
    (event) => {
      setFormData({ ...formData, [event.target.name]: event.target.value });
    },
    [formData]
  );

  const sendMail = useCallback(async (formData) => {
    try {
      const response = await axios.post(`${apiURL}/auth/contact`, formData);
      return response.data;
    } catch (error) {
      console.log(error.response);
      if (error.response.data) return error.response.data;
      return { success: false, message: error.message };
    }
  }, []);

  const onSubmitFormData = useCallback(
    async (event) => {
      event.preventDefault();
      try {
        const responseData = await sendMail(formData);
        if (!responseData.success) {
          setAlert({ type: 'error', message: responseData.message });
          setTimeout(() => {
            setAlert(null);
          }, 3000);
        } else {
          setAlert({ type: 'success', message: responseData.message });
          setTimeout(() => {
            setAlert(null);
            navigate('/products');
          }, 3000);
        }
      } catch (error) {
        console.log(error);
      }
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        content: '',
      });
    },
    [formData, navigate, sendMail]
  );

  return (
    <>
      {/* <!-- Breadcrumb Section Begin --> */}
      <section
        className="breadcrumb-section set-bg"
        style={{
          backgroundImage: 'url(img/breadcrumb.jpg)',
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="breadcrumb__text">
                <h2>{t('contact.title')}</h2>
                <div className="breadcrumb__option">
                  <Link to="/">{t('header.home')}</Link>
                  <span>{t('header.contact')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Breadcrumb Section End -->

    <!-- Contact Section Begin --> */}
      <section className="contact spad">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-6 text-center">
              <div className="contact__widget">
                <span className="icon_phone"></span>
                <h4>{t('contact.phone')}</h4>
                <p>{t('contact.phoneNumber')}</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 text-center">
              <div className="contact__widget">
                <span className="icon_pin_alt"></span>
                <h4>{t('contact.address')}</h4>
                <p>{t('contact.addressDetail')}</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 text-center">
              <div className="contact__widget">
                <span className="icon_clock_alt"></span>
                <h4>{t('contact.time')}</h4>
                <p>{t('contact.hours')}</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 text-center">
              <div className="contact__widget">
                <span className="icon_mail_alt"></span>
                <h4>Email</h4>
                <p>yumyum@hutech.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Contact Section End -->

    <!-- Map Begin --> */}
      <div className="map">
        <iframe
          title="Map"
          height="500"
          id="gmap_canvas"
          src="https://maps.google.com/maps?q=HUTECH+(YumYum)&t=&z=14&ie=UTF8&iwloc=&output=embed"
          frameBorder="0"
          scrolling="no"
          marginHeight="0"
          marginWidth="0"
        ></iframe>
      </div>
      {/* <!-- Map End -->

    <!-- Contact Form Begin --> */}
      <div className="contact-form spad">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="contact__form__title">
                <h2>{t('contact.message.title')}</h2>
              </div>
            </div>
          </div>
          <Suspense fallback={<Loading />}>
            <AlertMessage info={alert} />
          </Suspense>
          <form onSubmit={onSubmitFormData}>
            <div className="row">
              <div className="col-lg-12">
                <input
                  type="text"
                  placeholder={t('contact.message.name')}
                  name="fullName"
                  value={fullName}
                  onChange={onChangeFormData}
                  required
                />
              </div>
              <div className="col-lg-6 col-md-6">
                <input
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={onChangeFormData}
                  required
                />
              </div>
              <div className="col-lg-6 col-md-6">
                <input
                  type="text"
                  placeholder={t('contact.message.phone')}
                  name="phone"
                  value={phone}
                  onChange={onChangeFormData}
                  required
                />
              </div>
              <div className="col-lg-12 text-center">
                <textarea
                  placeholder={t('contact.message.form')}
                  name="content"
                  value={content}
                  onChange={onChangeFormData}
                  required
                ></textarea>
                <button type="submit" className="site-btn">
                  {t('contact.message.send')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* <!-- Contact Form End --> */}
    </>
  );
};

export default memo(Contact);
